// Fired on window with {detail: {validated}} so pages outside the app (the
// welcome page) can react too.
export const EMAIL_VALIDATED_EVENT = 'smashladder:email-validated';

// The server pushes {email_validated: bool} whenever a player's email starts
// or stops counting as confirmed (Player_Profile::save). Records it on my user
// and has notifyStore dispatch updatedMyUser, so the netplay notice
// (react/netplay/MyEmailVerificationNotice) updates.
export default function applyEmailValidated(emailValidated, { user, notifyStore, target }) {
	const validated = !!emailValidated;
	if(user && typeof user.update === 'function') {
		user.update({ email_validated: validated });
		notifyStore();
	}
	target.dispatchEvent(new CustomEvent(EMAIL_VALIDATED_EVENT, { detail: { validated } }));
}
